import React, { useState/* , useEffect  */ } from 'react';
import './LoginSignup.css'
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

import * as Constants from "../../constants/Constants";
import * as utils from "../../global/utils";
import * as AppUrls from "../../constants/AppUrls";
import * as Helpers from "../../global/Helpers";
import i18next from 'i18next';


toast.configure();

function ChangePassword() {
    const { t } = useTranslation();
    const [username, setUsername] = useState("");
    // const [oldPassword, setOldPassword] = useState("");
    const [oldPassword, setoldPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [redirect, setRedirect] = useState(null);
    const [visible, setVisible] = useState(false);

    // const errorNotify = (message) => {
    //     toast.error(message, {
    //         position: toast.POSITION.BOTTOM_CENTER,
    //         hideProgressBar: true,
    //         autoClose: Constants.errorNotifyDuration
    //     });
    // };

    function validate() {

        // if (!username) {
        //     errorNotify("Please enter username and try again.");
        //     return false;
        // }

        // if (!oldPassword) {
        //     errorNotify("Please enter old password and try again.");
        //     return false
        // }

        // if (!oldPassword) {
        //     errorNotify("Please enter old password and try again.");
        //     return false
        // }
        if (!password) {
            Helpers.errorNotify(t("Please_enter_password_and_try_again."), i18next.language);
            return false
        }

        if (!confirmPassword) {
            Helpers.errorNotify(t("Please_enter_confirm_password_and_try_again."), i18next.language);
            return false
        }


        if (password !== confirmPassword) {
            Helpers.errorNotify(t("passwordnotmatchconfirmedpassword"), i18next.language)
            return false;
        }

        return true;
    }

    function submit(e) {

        e.preventDefault();
        if (!validate()) {
            return;
        }
        callChangePasswordApi();
    }

    const callChangePasswordApi = async () => {

        setVisible(true);
        const params = {
            "UserName": localStorage.getItem("username"),//username,
            "Password": utils.encryptedString(password),
            "Password2": utils.encryptedString(confirmPassword),
            "MobileType": "",
            "SessionID": "",
            "UserIPAddress": "185.99.34.25",
            "TokenID": "",
            "HdnKey": "",
            "FingerPrintID": "",
            "FingerPrintLevel": "",
            "RegistrationId": "",
            "isAuthorizeOnly": "N",
            "OldPassword": localStorage.getItem("passwordToOTp"),
            "WebCode": localStorage.getItem("WebCode")
        };
        let url = Constants.baseURL + Constants.changesPassword;
        // let changesPasswordResponse = utils.changesPassword(params);
        // changesPasswordResponse
        let options = { withCredentials: true };

        await axios.post(url, params, options)
            .then((response) => {
                setVisible(false);
                //  console.log(response);
                
                var status = response.data["Status"];
                if (status === "0") {
                    // toast.success("Password changed Successfully.", {
                    //     position: toast.POSITION.BOTTOM_CENTER,
                    //     hideProgressBar: true,
                    //     autoClose: 1000
                    // });
                    Helpers.successNotify("Password changed Successfully.", i18next.language);

                    let user = JSON.stringify(response.data);
                    let webcode = response.data["WebCode"];
                    //localStorage.setItem("user", user);
                    localStorage.setItem("username", username);
                    localStorage.setItem("WebCode", webcode);
                    localStorage.setItem("isTermsAndConditions", response.data["isTermsAndConditions"]);

                    //window["connectionInitialize"](username, webcode);
                    
                    // if (response.data["isTermsAndConditions"] === "N" &&
                    //     ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false") || localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS")) {
                    //     setRedirect(AppUrls.TermsAndConditions);
                    // }
                    // else {
                    setRedirect(AppUrls.trading);
                    // }
                } else if (status === null) {
                    setRedirect(AppUrls.login);
                    // localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) :  setRedirect(AppUrls.login);

                } else {
                    
                    // Helpers.errorNotify(response.data[t("ErrorMsg"),i18next.language]) 
                    Helpers.errorNotify(response.data["ErrorMsg"], i18next.language)
                }
            })
            .catch((error) => {
                setVisible(false);
                console.log(error);
                Helpers.errorNotify(error.message, i18next.language);
            });

    }

    const callLogOff = () => {
        // 
        // props.setIsLoaderVisible(true);
        //console.log("logging out...");
        let logOffResponse = utils.logOff();
        logOffResponse
            .then((response) => {
                // props.setIsLoaderVisible(false);
                //console.log("Logged Off", response)
                if (response.status === 200) {
                    localStorage.removeItem("user");
                    localStorage.removeItem("ExpiredDocument");
                    let UserName = localStorage.getItem("username");
                    let RememberMe = localStorage.getItem("isRememberMe");
                    let language = localStorage.getItem("language");

                    let Comapnyname = localStorage.getItem(
                        Constants.localStorageConstants.company_name
                    );
                    var prev = Helpers.getPreviousConfig();
                    if (RememberMe === "true") {
                        localStorage.clear();
                        localStorage.setItem("isRememberMe", true);
                        localStorage.setItem("username", UserName);
                        localStorage.setItem("language", language);

                        localStorage.setItem(
                            Constants.localStorageConstants.company_name,
                            Comapnyname
                        );
                    } else {
                        localStorage.clear();
                        localStorage.setItem("language", language);

                        localStorage.setItem(
                            Constants.localStorageConstants.company_name,
                            Comapnyname
                        );
                    }
                    Helpers.SetpreviosConfig(prev);
                    setRedirect(AppUrls.login);
                    //   setState({ redirect: AppUrls.login }, () => {
                    //     disconnectSignalr();
                    //   });
                }
            })
            .catch((error) => {
                //props.setIsLoaderVisible(false);
                //console.log("error", error);
            });
    };

    var hideLoader = "";
    if (visible) {
        hideLoader = "";
    } else {
        hideLoader = "hide-loader";
    }


    if (redirect) {
        return <Redirect to={redirect} />;
    }

    return (
        <div className="AuthCont">
            <form name="form">
                <div className="center">
                    {/* <div className="form-group">
                        <input
                            className="input-textbox"
                            type="text"
                            name="email"
                            placeholder="User Name"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)} />
                    </div> */}
                    {/* <div className="form-group">
                        <input
                            className="input-textbox"
                            type="password"
                            name="password"
                            placeholder="Old Password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                    </div> */}
                    {/* <div className="form-group">
                        <input
                            className="input-textbox"
                            type="password"
                            name="Oldpassword"
                            placeholder="Old Password"
                            value={oldPassword}
                            onChange={(e) => setoldPassword(e.target.value)}
                        />
                    </div> */}
                    <div className="form-group">
                        <input
                            className="input-textbox"
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className="input-textbox"
                            type="password"
                            name="confirm password"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                </div>
                <div className="form-group center form-group-btns">
                    <button className="auth-btns btn btn-primary" style={{ width: "50%" }} onClick={submit}>
                        Change Password
                    </button>
                </div>
                <div>
                    <button
                        className={"link"}
                        style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer"
                        }}
                        onClick={
                            (event) => {
                                event.preventDefault();
                                // setRedirect(AppUrls.login);
                                callLogOff();
                                //  localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) :  setRedirect(AppUrls.login);
                            }}
                    >
                        {t("cancelForgotPassword")}
                    </button>
                </div>
            </form>
            <div className={"center-loader" + hideLoader} style={{ backgroundColor: "#FFFFFFD9" }}>
                <Loader
                    type="Bars"
                    color="#00BFFF"
                    height={100}
                    width={100}
                    visible={visible}
                />
            </div>
        </div>
    );
}

export default ChangePassword;